import {
  COACH_PROGRAM_LIBRARY_ARCHIVED_ROUTE,
  COACH_PROGRAM_LIBRARY_PUBLISHED_ROUTE,
} from "../../routes/routes";

export const programTemplateLibraryNavigation = [
  {
    name: "Published",
    link: COACH_PROGRAM_LIBRARY_PUBLISHED_ROUTE,
  },

  {
    name: "Archived",
    link: COACH_PROGRAM_LIBRARY_ARCHIVED_ROUTE,
  },
];
